export const ALLOWED_RESUME_MIME_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
]

export const ALLOWED_RESUME_EXTENSIONS = [
    "pdf",
    "doc",
    "docx"
]
